import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';

dayjs.extend(durationPlugin);

export enum DurationParts {
  years = 'years',
  months = 'months',
  days = 'days',
  hours = 'hours',
  minutes = 'minutes',
  seconds = 'seconds',
  milliseconds = 'milliseconds',
}

export const getDurationParts = (
  value: number,
  unit = DurationParts.seconds,
  minPartsCount?: number
) => {
  const duration = dayjs.duration(value, unit);

  const parts: [DurationParts, number][] = [];

  for (const part in DurationParts) {
    if (Object.prototype.hasOwnProperty.call(DurationParts, part)) {
      const partValue = duration.get(part as DurationParts);

      if (partValue || parts.length) {
        parts.push([part as DurationParts, partValue]);
      }
    }
  }

  if (minPartsCount && parts.length < minPartsCount) {
    const possibleParts = Object.values(DurationParts);

    const durationPartByIndex = Object.fromEntries(
      possibleParts.map((part, index) => [index, part])
    );

    const zeroParts: [DurationParts, number][] = [
      ...new Array(minPartsCount - parts.length),
    ].map((_, index) => [
      durationPartByIndex[possibleParts.length - minPartsCount + index],
      0,
    ]);

    parts.unshift(...zeroParts);
  }

  return parts;
};
